<template>
  <f7-page name="ko-tabulka" @page:init="onPageInit">
    <f7-navbar>
      <f7-nav-left>
        <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
      </f7-nav-left>
      <f7-nav-title sliding>Aktuálne koncentrácie</f7-nav-title>
      <f7-nav-right>
        <f7-link icon-ios="f7:arrow_2_circlepath" icon-aurora="f7:arrow_2_circlepath" icon-md="material:autorenew" @click="pageReload($event,false) " href="#" ></f7-link>
        <f7-link icon-ios="f7:arrow_left" icon-aurora="f7:arrow_left" icon-md="material:arrow_back" @click="$f7router.back()" href="#" ></f7-link>
      </f7-nav-right>
    </f7-navbar>

    <f7-block strong class="no-padding mt-0 mb-5 no-border-top">
      <template v-if="smogListDataLoaded">


        <f7-block strong class="mt-0 mb-0 text-align-center padding-half z-index-200 position-sticky top-0">
          <f7-row>
            <f7-col width="25">
              <f7-button class="smog-btn-prev" :disabled="selected_dt <= min_dt" @click="setSelectedDt(-1)" icon-f7="arrow_left"></f7-button>
            </f7-col>
            <f7-col class="padding-top-half" width="50">
              {{ selected_dt * 1000 | moment('DD.MM.YYYY HH:mm') }}
            </f7-col>
            <f7-col width="25">
              <f7-button class="smog-btn-next" :disabled="selected_dt >= max_dt" @click="setSelectedDt(1)" icon-f7="arrow_right"></f7-button>
            </f7-col>
          </f7-row>
          <f7-row>
            <f7-col>
              <f7-searchbar
                  search-container=".search-list"
                  search-in=".item-title"
                  placeholder="Hľadať..."
                  disable-button-text="Zrušiť"
                  :remove-diacritics="true"
                  :disable-button="!$theme.aurora"
              ></f7-searchbar>
            </f7-col>
          </f7-row>
        </f7-block>

        <template v-if="smogListDataSHMU.length > 0">
          <f7-list class="searchbar-not-found no-margin-top">
            <f7-list-item title="Nič nebolo nájdené..." subtitle="Skúste zmeniť parametre vyhľadávania..."></f7-list-item>
          </f7-list>
          <f7-list-item divider title="Stanice SHMÚ"></f7-list-item>
          <f7-list media-list class="search-list searchbar-found no-margin-top vodnestavy">
            <f7-list-item v-for="(item, index) in smogListDataSHMU"
                          :key="item.station.station_id"
                          :link="'/kvalita-ovzdusia/detail/'+item.station.station_id"
                          :title="item.station.station_name"
            >
              <div class="item-footer-x">
                <table class="smog-table-small data-table">
                  <thead>
                  <tr>
                    <th v-for="item in smogListSHMUPollutants" :key="item.pollutant_id" class="numeric-cell text-align-center" v-html="replacePollutantDesc(item.pollutant_desc)"></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td v-for="sub_item in smogListSHMUPollutants" :key="`${item.station.station_id}-${sub_item.pollutant_id}`"
                        :class="'numeric-cell text-align-center oko_'+getSmogLimitLevelSHMU(item.station.station_id, sub_item.pollutant_id)"
                        class="numeric-cell text-align-center">
                      {{ getSmogValueSHMU(item.station.station_id, sub_item.pollutant_id) }}
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </f7-list-item>
            <f7-list-item divider title="Stanice ostatných prevádzkovateľov"></f7-list-item>
            <f7-list-item v-for="(item, index) in smogListDataOthers"
                          :key="item.station.station_id"
                          :link="'/kvalita-ovzdusia/detail/'+item.station.station_id"
                          :title="item.station.station_name"
            >
              <div class="item-footer-x">
                <table class="smog-table-small data-table">
                  <thead>
                  <tr>
                    <th v-for="item in smogListOthersPollutants" :key="item.pollutant_id" class="numeric-cell text-align-center" v-html="replacePollutantDesc(item.pollutant_desc)"></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td v-for="sub_item in smogListOthersPollutants" :key="`${item.station.station_id}-${sub_item.pollutant_id}`"
                        :class="'numeric-cell text-align-center oko_'+getSmogLimitLevelOther(item.station.station_id, sub_item.pollutant_id)"
                        class="numeric-cell text-align-center">
                      {{ getSmogValueOthers(item.station.station_id, sub_item.pollutant_id) }}
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </f7-list-item>
          </f7-list>
        </template>



        <h4 class="text-align-center">Legenda</h4>
        <div class="card z-index-100 data-table">
          <table class="smog-table-legenda">
            <thead>
              <tr>
                <th>Kvalita<br>Veličina</th>
                <th class="oko_0">veľmi<br>dobrá</th>
                <th class="oko_1">dobrá</th>
                <th class="oko_2">zhoršená</th>
                <th class="oko_3">zlá</th>
                <th class="oko_4">veľmi<br>zlá</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>PM<sub>10</sub><br><small>1h - &micro;g/m<sup>3</sup></small></td>
                <td>0 - 20</td>
                <td>&gt;20 - 40</td>
                <td>&gt;40 - 100</td>
                <td>&gt;100 - 180</td>
                <td>&gt;180</td>
              </tr>
              <tr>
                <td>PM<sub>2,5</sub><br><small>1h - &micro;g/m<sup>3</sup></small></td>
                <td>0 - 14</td>
                <td>&gt;14 - 25</td>
                <td>&gt;25 - 70</td>
                <td>&gt;70 - 140</td>
                <td>&gt;140</td>
              </tr>
              <tr>
                <td>O<sub>3</sub><br><small>1h - &micro;g/m<sup>3</sup></small></td>
                <td>0 - 33</td>
                <td>&gt;33 - 65</td>
                <td>&gt;65 - 180</td>
                <td>&gt;180 - 240</td>
                <td>&gt;240</td>
              </tr>
              <tr>
                <td>SO<sub>2</sub><br><small>1h - &micro;g/m<sup>3</sup></small></td>
                <td>0 - 25</td>
                <td>&gt;25 - 50</td>
                <td>&gt;50 - 350</td>
                <td>&gt;350 - 500</td>
                <td>&gt;500</td>
              </tr>
              <tr>
                <td>CO<br><small>1h - &micro;g/m<sup>3</sup></small></td>
                <td>0 - 1000</td>
                <td>&gt;1000 - 2000</td>
                <td>&gt;2000 - 10000</td>
                <td>&gt;10000 - 30000</td>
                <td>&gt;30000</td>
              </tr>
              <tr>
                <td>NO<sub>2</sub><br><small>1h - &micro;g/m<sup>3</sup></small></td>
                <td>0 - 20</td>
                <td>&gt;20 - 40</td>
                <td>&gt;40 - 200</td>
                <td>&gt;200 - 400</td>
                <td>&gt;400</td>
              </tr>
              <tr>
                <td class="oko_g">&nbsp;</td><td colspan="5" class="text-align-left">znečisťujúca látka sa na tejto stanici nemeria</td>
              </tr>
              <tr>
                <td class="oko_0 font-weight-normal">PDL</td><td colspan="5" class="text-align-left">pod detekčný limit</td>
              </tr>
              <tr>
                <td class="oko_w font-weight-normal">*</td><td colspan="5" class="text-align-left">hodnoty pre túto znečisťujúcu látku nie sú momentálne dostupné</td>
              </tr>
              <tr>
                <td class="oko_w font-weight-normal">**</td><td colspan="5" class="text-align-left">reinštalácia zariadenia</td>
              </tr>
              <tr><td colspan="6" style="font-weight:normal; text-align:left; white-space:pre-wrap;">
                <ul class="mt-0 pl-1">
                  <li>Hodnoty koncentrácie plynných ZL s výnimkou ortuti (Hg) sú uvedené v  µg/m<sup>3</sup> (mikrogramoch na meter kubický).</li>
                  <li>Hodnota ortuti (Hg) je uvedená v ng/m3 (nanogramoch na meter kubický).</li>
                  <li>Hodnoty všetkých plynných ZL sú prepočítané na štandardné stavové podmienky (teplota 20°C (293,15 K) a tlak 101,325 kPa).</li>
                  <li>Hodnoty koncentrácie aerosólov PM<sub>10</sub> a PM<sub>2,5</sub> sú uvedené v µg/m<sup>3</sup> (mikrogramoch na meter kubický) pri podmienkach okolia.</li>
                  <li>Údaje sú nevalidované.</li>
                </ul>

              </td> </tr>
            </tbody>
          </table>

        </div>

      </template>

    </f7-block>

  </f7-page>
</template>
<script>
import Axios from "axios";
import SHMUconf from "../js/SHMUconf";
import { latLng } from "leaflet";
import { LMap, LTileLayer, LImageOverlay, LMarker, LGeoJson } from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';
import l_smogORKOGeoJson from "../static/shmu/maps/ORKO_2017_WGS84_lite.min"
import l_smogOkresyGeoJson from "../static/shmu/maps/hranice_okresy3.min"
import PinchZoom from 'vue-pinch-zoom';

var smog_icn_markers = [];

var defaultStyle = {
  fillColor: 'rgba(0,0,0,0.5)'
};

var yellowStyle = {
  fillColor: 'rgba(255, 255, 0, 0.8)'
};

var redStyle = {
  fillColor: 'rgba(255, 0, 0, 0.8)'
};

var orangeStyle = {
  fillColor: 'rgba(255, 102, 0, 0.8)'
};

var oko_style = {
  fillColor: 'rgba(100, 100, 100, 0)',
  fillOpacity:0,
  weight:0,
};



var okoStyles = {
  '0'        : defaultStyle,
  'red'      : redStyle,
  'orange'   : orangeStyle,
  'yellow'   : yellowStyle,
};


export default {
  components: {
    'pinch-zoom': PinchZoom
  },
  data: function () {
    return {
      lastUpdated: 0,
      tCheckInterval: null,
      lastUpdatedSmogListData: 0,
      smogListData: [],
      smogListSHMUPollutants: [],
      smogListOthersPollutants: [],
      smogListStations: [],
      smogListDataLoaded: false,
      selected_dt: null,
      min_dt: null,
      max_dt: null,
      baseUrl: SHMUconf.SHMU_CORE_URL,

    };
  },
  watch: {
    smogListData() {
      if (this.smogListData && this.smogListData.length > 0) {
        this.smogListData.forEach(item => {
          if (item.data.length > 0) {
            item.data.forEach(sub_item => {
              if (this.min_dt === null) this.min_dt = sub_item.dt;
              if (this.max_dt === null) this.max_dt = sub_item.dt;
              if (sub_item.dt > this.max_dt) this.max_dt = sub_item.dt;
              if (sub_item.dt < this.min_dt) this.min_dt = sub_item.dt;
            });
          }
          let exists = this.smogListStations.find(inner => item.station.station_id === inner.station_id);
          if (!exists) this.smogListStations.push(item.station);
        });
        this.selected_dt = this.max_dt;
        this.min_dt = this.$moment(this.max_dt*1000).add(-23,'hours').unix(); // na pevno -24hodin
      }
    }
  },
  computed:{

    smogListDataSHMU() {
      let list = this.smogListData.filter(item => item.station.type === 1);
      list.forEach((v) => {
        v.station.pollutants.forEach(item => {
          let exists = this.smogListSHMUPollutants.find(inner => item.pollutant_id === inner.pollutant_id);
          if (!exists) this.smogListSHMUPollutants.push(item);
        });
        this.smogListSHMUPollutants.sort((a, b) => (a.order > b.order) ? 1 : -1)
      });
      return list;
    },
    smogListDataOthers() {
      let list = this.smogListData.filter(item => item.station.type === 2);
      list.forEach((v) => {
        v.station.pollutants.forEach(item => {
          let exists = this.smogListOthersPollutants.find(inner => item.pollutant_id === inner.pollutant_id);
          if (!exists) this.smogListOthersPollutants.push(item);
        });
      });
      this.smogListOthersPollutants.sort((a, b) => (a.order > b.order) ? 1 : -1)
      return list;
    }
  },
  mounted() {
    const self = this;
    // otvorime hlavne menu
    this.$f7.accordion.close('.shmu-i-kvalita-ovzdusia');
    this.$f7.accordion.open('.shmu-i-kvalita-ovzdusia');



  },
  destroy() {
    clearInterval(this.tCheckInterval);
  },
  methods: {
    onPageInit() {
      this.pageReload(null, true);
    },
    pageReload(event, isInit) {
      const self = this;

      if (isInit) {
        this.loadSmogListData();
      }

      if (!isInit && this.smogListDataLoaded && (this.$moment().unix() - this.lastUpdatedSmogListData) > 5 * 60) {
        this.loadSmogListData();
      }

    },


    loadSmogListData: function() {
      const self = this;

      let cached = self.$ls.get('smog_list_data');
      if (cached !== null) {
        self.smogListData = cached;
        self.smogListDataLoaded = true;
      } else {

        self.$f7.dialog.preloader('Načítavam...');
        Axios.get(SHMUconf.API_BASE_URL + 'airquality/getdata?history=24&station_meta=1', {
          crossDomain: true,
          cache: false,
        })
            .then((response) => {
              if (!response.data.error) {
                self.smogListData = response.data;
                self.smogListDataLoaded = true;
                self.lastUpdatedSmogListData = self.$moment().unix();
                self.$ls.set('smog_list_data', self.smogListData, 10 * 60 * 1000); //  0 min
                // clearInterval(this.tCheckInterval);
                // this.tCheckInterval = setInterval(this.checkLastUpdated, 2 * 60 * 1000); // overujem kazdych 5 min

              } else {
                self.$f7.dialog.alert('Nepodarilo sa načítať údaje o kvalite ovzdušia', 'Nastala chyba');
              }
              self.$f7.dialog.close();
            }).catch((error) => {
          self.$f7.dialog.close();
          self.$f7.dialog.alert('Nepodarilo sa nadviazať spojenie so serverom SHMÚ', 'Nastala chyba spojenia');
        });
      }
    },
    getSmogValueSHMU: function(station_id, pollutant_id) {
      let item = this.fetchSmogDataItem(this.smogListDataSHMU, station_id, pollutant_id);

      let station = this.smogListStations.find(inner => station_id === inner.station_id);
      if (station) {
        let poll = station.pollutants.find(inner => pollutant_id === inner.pollutant_id);
        if (item === false && poll) return '*';
      }

      if (item === false) return '';
      return item.value;
    },
    getSmogLimitLevelSHMU: function(station_id, pollutant_id) {
      let item = this.fetchSmogDataItem(this.smogListDataSHMU, station_id, pollutant_id);

      let station = this.smogListStations.find(inner => station_id === inner.station_id);
      if (station) {
        let poll = station.pollutants.find(inner => pollutant_id === inner.pollutant_id);
        if (item === false && !poll) return 'g';
      }

      if (item === false) return '';
      if (typeof item.limit_level !== "undefined") {
        return item.limit_level;
      }
      return '';
    },
    getSmogValueOthers: function(station_id, pollutant_id) {
      let item = this.fetchSmogDataItem(this.smogListDataOthers, station_id, pollutant_id);

      let station = this.smogListStations.find(inner => station_id === inner.station_id);
      if (station) {
        let poll = station.pollutants.find(inner => pollutant_id === inner.pollutant_id);
        if (item === false && poll) return '*';
      }

      if (item === false) return '';
      return item.value;
    },
    getSmogLimitLevelOther: function(station_id, pollutant_id) {
      let item = this.fetchSmogDataItem(this.smogListDataOthers, station_id, pollutant_id);

      let station = this.smogListStations.find(inner => station_id === inner.station_id);
      if (station) {
        let poll = station.pollutants.find(inner => pollutant_id === inner.pollutant_id);
        if (item === false && !poll) return 'g';
      }

      if (item === false) return '';
      if (typeof item.limit_level !== "undefined") {
        return item.limit_level;
      }
      return '';
    },
    fetchSmogDataItem: function(source, station_id, pollutant_id) {
      let st = source.find(item => item.station.station_id === station_id);
      if (!st) return false;
      if (st.data.length === 0) return '-';
      let data = st.data.find(item => item.dt === this.selected_dt && item.pollutant_id === pollutant_id);
      if (!data) return false;
      return data;
    },
    replacePollutantDesc: function(desc) {
      switch (desc) {
        case 'PM10': return 'PM<sub>10</sub>';
        case 'PM2.5': return 'PM<sub>2.5</sub>';
        case 'NO2': return 'NO<sub>2</sub>';
        case 'NOX': return 'NO<sub>X</sub>';
        case 'O3': return 'O<sub>3</sub>';
        case 'SO2': return 'SO<sub>2</sub>';
        default: return desc;
      }
    },
    setSelectedDt: function(offset) {
      let new_dt = this.$moment(this.selected_dt*1000).add(offset, 'hour');
      if ((new_dt/1000) > this.max_dt) return;
      if ((new_dt/1000) < this.min_dt) return;

      this.selected_dt = new_dt.unix();
    },


  }

};
</script>

<style lang="scss">



.smog-table-legenda {
  border-collapse:collapse;
  td, th {
    padding: 3px 2px;
    border-right: 1px solid var(--f7-table-cell-border-color);
    border-collapse:collapse;
    &:first-child { border-left: 0;}
    &:last-child { border-right: 0;}
    height: 20px !important;
    white-space: nowrap;
    text-align: center;
  }
  th {
    text-align:center;

  }
  td {
    &:first-child { font-weight:bold;}
    font-size:10px;
  }

}
.smog-table {
  border-collapse: collapse;

  tr {
    border: 0px;
  }

  td, th {
    padding: 3px 5px;
    min-width: 50px;
    border-right: 1px solid var(--f7-table-cell-border-color);
    border-collapse: collapse;
    height: 30px !important;
    &:first-child {
      border-left: 0;
    }

    &:last-child {
      border-right: 0;
    }
  }
  th {
    font-weight: bold !important;
    font-size: 12px !important;
  }

}

.smog-table-small {
  border-collapse: collapse;

  /*
  tr {
    border: 0px;
  }
   */
  td, th {
    padding: 3px 5px;
    min-width: 20px;
    border: 1px solid var(--f7-table-cell-border-color);
    border-collapse: collapse;
    height: 20px !important;
    font-size: 10px !important;
    /*
    &:first-child {
      border-left: 0;
    }
    */

    /*
    &:last-child {
      border-right: 0;
    }

     */
  }
  th {
    font-weight: bold !important;
    font-size: 10px !important;
  }
}

.smog-spa-1 {
  background-color: #FF6600;
  color: white;
}

.smog-spa-2 {
  background-color: red;
  color: white;
}

.smog-spa-3 {
  background-color: #FF6600;
  color: white;
}

.smog-spa-4 {
  background-color: red;
  color: white;
}

.smog-spa-5 {
  background-color: yellow;
  color: black;
}

.smog-map {
  width: 100%;
  height: 100%;

  .leaflet-top .leaflet-control {
    margin-top: 40px !important;
  }
}

.i-label2 {
  font-weight: bold;
  color:white;
}

.smog-toolbar {
  text-align: center;
  font-size:0.8em;
  width:100%;
  margin:0;
  padding: 0;
}

#tab-smog-map {
  height:100%;
  width:100%;
}

.iswarning {
  font-weight:bold;
  color:red;
  animation:blinkingText 1.2s infinite;
}

@keyframes blinkingText{
  0%{     color: red;    }
  49%{    color: red; }
  60%{    color: #000; }
  99%{    color: #000;  }
  100%{   color: red;    }
}

.oko_0 {
  background: #00b050 !important;;
}
.oko_1 {
  background: #92d050 !important;;
}
.oko_2 {
  background: #ffff00 !important;;
}
.oko_3 {
  background: #ffc000 !important;;
}
.oko_4 {
  background: #ff0000 !important;;
  color: white !important;
}
.oko_w {
  background: #ffffff !important;
  color: var(--f7-block-strong-text-color) !important;
}
.oko_g {
  background: #e8e8e8 !important;
  color: var(--f7-block-strong-text-color) !important;
}


.position-sticky  {
  position: -webkit-sticky;
  position: sticky !important;
}
.top-0 {
  top: 0;
}

.z-index-100 {
  z-index: 100;
}

.z-index-110 {
  z-index: 110;
}

.z-index-120 {
  z-index: 120;
}


.z-index-200 {
  z-index: 200;
}

.ko-header-cell {
  position: sticky !important;
  position: -webkit-sticky !important;
  top: 52px;
  background-color: var(--f7-navbar-bg-color, var(--f7-bars-bg-color)) !important;
  z-index:100 !important;
}

</style>
